(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-accessibility-status.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-accessibility-status.js');
"use strict";


const {
  useState,
  useEffect
} = React;
setGlobal('svs.ticketgames.ticketUtility.utils.useAccessibilityStatus', _ref => {
  let {
    isEInstant = false
  } = _ref;
  const [demoLoadingMsg, setDemoLoadingMsg] = useState('');
  useEffect(() => {
    if (!isEInstant) {
      setDemoLoadingMsg('Spelet håller på att laddas');
      let showingDemoBadge = false;
      const handleTag = data => {
        if (data.detail) {
          const {
            event,
            requestResponse = {},
            eventType,
            name
          } = data.detail;
          if (event === 'createITGBet' && eventType === 'requestResponse' && requestResponse.data) {
            if (requestResponse.data.demo) {
              showingDemoBadge = true;
              setDemoLoadingMsg('Animation för provlott. Spelet startar snart');
            } else {
              setDemoLoadingMsg('');
            }
          } else if (event === 'getItgTicket' && eventType === 'requestResponse') {
            showingDemoBadge = true;
          } else if (event === 'state' && eventType === 'view' && name === 'reveal' && showingDemoBadge) {
            setDemoLoadingMsg('');
            showingDemoBadge = false;
          }
        }
      };
      const handlePreBet = data => {
        if (data.detail) {
          const {
            demo
          } = data.detail;
          if (!demo) {
            setDemoLoadingMsg('');
          }
        }
      };
      addEventListener('TAG', handleTag);
      addEventListener('HANDLE_PREBET', handlePreBet);
    }
  }, []);
  return {
    demoLoadingMsg
  };
});

 })(window);